import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Typography from '../../Typography';
import Grid from '../../Grid';
import { CustomerContext } from '../../../contexts/CustomerContext';
import styles from './StudentInfo.module.sass';
import AccessCodeOnlyText from './AccessCodeOnlyText';

const StudentInfo = ({ student, accessCodeOnly }) => {
  const { customer: { currentSchool } } = useContext(CustomerContext);

  if (accessCodeOnly) return <AccessCodeOnlyText />

  return (
    <Grid id="student-info-container" container item direction='column' alignItems='center' xs={12} classes={styles.studentInfo}>
      <Typography>{`${student.lastName}, ${student.firstName}`}</Typography>
      <Typography>{`Grade ${student.grade}`}</Typography>
      <Typography>{currentSchool.name}</Typography>
    </Grid>
  )
};

StudentInfo.propTypes = {
  accessCodeOnly: PropTypes.bool.isRequired,
  student: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    grade: PropTypes.string.isRequired,
  }),
}

export default StudentInfo
